import { useEffect } from 'react';

const useNavScroll = () => {
  useEffect(() => {
    const nav = document.getElementById('navbar');
    if (!nav) return;

    const handleScroll = () => {
      if (window.scrollY > 60) {
        nav.classList.add('scrolled');
      } else {
        nav.classList.remove('scrolled');
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
};

export default useNavScroll;